import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    videoforms: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_VIDEOFORM_SELECT_IDS (store, ids) {
      store.videoforms.selectIds = ids
    },
    REMOVE_VIDEOFORM_SELECT_IDS (store, ids) {
      store.videoforms.selectIds = store.videoforms.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_VIDEOFORM_SELECT_ID (store, id) {
      store.videoforms.selectId = id
    },
    SET_VIDEOFORM_FILTERS (store, filters) {
      store.videoforms.filters = filters
    },
    SET_VIDEOFORM_PAGINATE (store, val) {
      store.videoforms.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getVideoforms: (store, getters) => {
      return store.videoforms.selectIds.map((id) => {
        return getters['entities/videoforms/find'](id)
      })
    },
    getVideoformsFilters: (store, getters) => {
      return store.videoforms.filters
    },
    getVideoformsPaginate: (store, getters) => {
      return store.videoforms.paginate
    },
    getVideoform: (store, getters) => {
      return getters['entities/videoforms/find'](store.videoforms.selectId) || {}
    }
  },
  actions: {
    /*
    selectVideoforms
    */
    selectVideoforms ({commit, dispatch, getters, state}, filters) {
      return dispatch('getVideoforms', filters)
      .then((response) => {
        commit('SET_VIDEOFORM_FILTERS', filters)
        commit('SET_VIDEOFORM_PAGINATE', response)
        commit('SET_VIDEOFORM_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectVideoforms
    */
    refreshSelectVideoforms ({commit, dispatch, getters, state}) {
      return dispatch('selectVideoforms', getters.getVideoformsFilters)
    },
    /*
    selectVideoform
    */
    selectVideoform ({commit, dispatch, getters, state}, id) {
      return dispatch('getVideoformById', id)
      .then((response) => {
        commit('SET_VIDEOFORM_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getVideoforms
    */
    getVideoforms ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/videoforms`, {params: filters})
      .then((response) => {
        return dispatch('entities/videoforms/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.videoforms || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getVideoformById
    */
    getVideoformById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/videoforms/${id}`)
      .then((response) => {
        return dispatch('entities/videoforms/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.videoforms[0]
      })
    },
    /*
    createVideoform
    */
    createVideoform ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/videoforms`, data)
      .then((response) => {
        return dispatch('entities/videoforms/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.videoforms[0]
      })
    },
    /*
    updateVideoform
    */
    updateVideoform ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/videoforms/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/videoforms/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.videoforms[0]
      })
    },
    /*
    deleteVideoform
    */
    deleteVideoform ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/videoforms/${id}`)
      .then((response) => {
        commit('REMOVE_VIDEOFORM_SELECT_IDS', [id])
        dispatch('entities/videoforms/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Videoform.js